import Axios from 'axios';

const getDefaultState = () => {
  return {
    questions: [],
    questionsLoading: false,
    answers: [],
    answersLoading: false
  };
};

const state = getDefaultState();

const getters = {
  getMaxScoreByQuestionId: state => questionId => {
    const index = state.questions.findIndex(x => x.question_id == questionId);

    if (index >= 0) {
      return state.questions[index].max_score;
    }

    return '';
  },

  getAnswerScore: state => answerId => {
    const index = state.answers.findIndex(x => x.answer_id == answerId);

    if (index >= 0) {
      return state.answers[index].score;
    }

    return 0;
  },

  getAnswersScoreSum: state => params => {
    const answers = state.answers.filter(x => x.question_id == params.questionId && x.answer_id != params.answerId);
    let sum = 0;

    for (let i = 0; i < answers.length; i++) {
      sum += Number(answers[i].score);
    }

    return sum;
  }
};

const mutations = {
  SET_QUESTIONS: (state, questions) => {
    state.questions = questions;
  },

  SET_QUESTIONS_LOADING: (state, questions) => {
    state.questionsLoading = questions;
  },

  SET_ANSWERS: (state, questions) => {
    state.answers = questions;
  },

  SET_ANSWERS_LOADING: (state, questions) => {
    state.answersLoading = questions;
  },

  RESET_STATE: state => {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  async fetchQuestions({ commit }, testId) {
    commit('SET_QUESTIONS_LOADING', true);

    await Axios.get(`/1.0/spec-private/custom-process/test/question/${testId}`)
      .then(response => {
        commit('SET_QUESTIONS', response.data.data);
      })
      .finally(() => {
        commit('SET_QUESTIONS_LOADING', false);
      });
  },

  async setDefaultValuesForMaxScore({ commit, dispatch, getters }, params) {
    commit('SET_QUESTIONS_LOADING', true);

    for (let i = 0; i < params.questions.length; i++) {
      // При условии что тип вопроса выбран multichoice (несколько вариантов ответа) и сумма ответов может быть больше чем 3. В остальных случаях ответ 1 и максимальный балл на любой ответ итак будет 3.
      if (!getters.getMaxScoreByQuestionId(params.questions[i].id) && params.questions[i].type === 'multichoice') {
        await dispatch('setQuestionScore', {
          max_score: 3,
          question_id: params.questions[i].id,
          test_id: params.testId
        });
      }
    }

    commit('SET_QUESTIONS_LOADING', false);
  },

  async setQuestionScore({ commit, dispatch }, params) {
    commit('SET_QUESTIONS_LOADING', true);

    await Axios.put(`/1.0/spec-private/custom-process/test/question`, params)
      .then(async () => {
        await dispatch('fetchQuestions', params.test_id);
      })
      .catch(() => {
        this._vm.$noty.error('Значение не записалось. Если ошибка повторится обратитесь в поддержку.');
      })
      .finally(() => {
        commit('SET_QUESTIONS_LOADING', false);
      });
  },

  async deleteQuestionScore({ commit, dispatch }, params) {
    commit('SET_QUESTIONS_LOADING', true);

    await Axios.delete(`/1.0/spec-private/custom-process/test/question/${params.questionId}`)
      .then(async () => {
        await dispatch('fetchQuestions', params.testId);
      })
      .finally(() => {
        commit('SET_QUESTIONS_LOADING', false);
      });
  },

  // answers
  async fetchAnswers({ commit }, testId) {
    commit('SET_ANSWERS_LOADING', true);

    await Axios.get(`/1.0/spec-private/custom-process/test/answer/${testId}`)
      .then(response => {
        commit('SET_ANSWERS', response.data.data);
      })
      .finally(() => {
        commit('SET_ANSWERS_LOADING', false);
      });
  },

  async setAnswerScore({ commit, dispatch }, params) {
    commit('SET_ANSWERS_LOADING', true);

    await Axios.put(`/1.0/spec-private/custom-process/test/question-answer`, params)
      .then(async () => {
        await dispatch('fetchAnswers', params.testId);
      })
      .catch(() => {
        this._vm.$noty.error('Значение не записалось. Если ошибка повторится обратитесь в поддержку.');
      })
      .finally(() => {
        commit('SET_ANSWERS_LOADING', false);
      });
  },

  async deleteAnswerScore({ commit, dispatch }, params) {
    commit('SET_ANSWERS_LOADING', true);

    await Axios.delete(`/1.0/spec-private/custom-process/test/question-answer/${params.answerId}`)
      .then(async () => {
        await dispatch('fetchAnswers', params.testId);
      })
      .finally(() => {
        commit('SET_ANSWERS_LOADING', false);
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
